import { http } from "@/services/http";
import {
  LoginResponseSchema,
  LoginSchema,
  UserSchema,
  type AuthUser,
} from "./auth.schema";

export async function login(payload: unknown) {
  const data = LoginSchema.parse(payload);

  await http.get("/sanctum/csrf-cookie");

  const response = await http.post("/login", data);

  return LoginResponseSchema.parse(response.data);
}

export async function logout() {
  await http.post("/logout");
}

export async function getCurrentUser(): Promise<AuthUser> {
  const { data } = await http.get("/user");

  return UserSchema.parse(data);
}
